<template>
  <vs-popup class="status-log-pop-up"
            :title="computedTitle"
            @close="isActive = false"
            :active.sync="isActive"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div slot="no-body" class="mt-4">
        <vs-table
          :key="tableKey"
          id="status-log-table"
          :max-items="meta.per_page ? meta.per_page : 10"
          :data="logs"
          stripe
          class="table-dark-inverted table-auto vs-con-loading__container">

          <template slot="thead">
            <vs-th v-for="col in columns" :key="col.label" :width="col.width">{{ col.label }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <slot name="rows" :data="data" :buildDiffRows="buildDiffRows" />
          </template>

        </vs-table>

        <vs-pagination
          v-on:changeMaxItems="changePage"
          :size-array="meta.total ? meta.total : 20"
          :max-items="perPage"
          description-body="Rows per page"
          description-connector="of"
          description-title="Records"
          description
          :description-items="descriptionItems"
          :total="meta.last_page ? meta.last_page : 0"
          v-model="page"
          class="p-5">
        </vs-pagination>

      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import { defaultPagination, perPageList } from '@/constants/config'

function initialState() {
  return {
    isActive: false,
    logs: [],
    page: 1,
    meta: {},
    perPage: defaultPagination,
    descriptionItems: perPageList,
    id: null,
    subtitle: '',
    extraParams: {},
  }
}

export default {
  name: 'StatusLogPopUp',
  props: {
    title: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    fetchFn: {
      type: Function,
      required: true,
    },
  },
  data() {
    return { ...initialState(), tableKey: 0 }
  },
  computed: {
    computedTitle() {
      return this.subtitle ? `${this.subtitle} - ${this.title}` : this.title
    },
  },
  methods: {
    async openPopup(id, { subtitle = '', extraParams = {} } = {}) {
      Object.assign(this.$data, initialState())
      this.tableKey++
      this.id = id
      this.subtitle = subtitle
      this.extraParams = extraParams
      this.isActive = true
      await this.fetchLogs()
    },
    async fetchLogs() {
      await this.$vs.loading({
        container: '#status-log-table',
        scale: 0.45,
      })
      try {
        const { logs, meta } = await this.fetchFn(this.id, this.page, this.perPage, this.extraParams)
        this.logs = logs
        this.meta = meta
      } catch (e) {
        this.$vs.notify({ title: 'Error', text: 'Could not load logs', color: 'danger' })
      }
      this.$vs.loading.close('#status-log-table > .con-vs-loading')
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    buildDiffRows(properties) {
      if (!properties || (!properties.old && !properties.new)) return []
      const flatten = (obj, parent, res) => {
        parent = parent || ''; res = res || {}
        if (!obj) return res
        Object.keys(obj).forEach(key => {
          const val = obj[key], path = parent ? `${parent}.${key}` : key
          if (Array.isArray(val)) {
            val.forEach((v, i) => {
              const seg = (v && v.log_label) ? `(${v.log_label})` : `[${i}]`
              typeof v === 'object' && v ? flatten(v, `${path}.${seg}`, res) : (res[`${path}.${seg}`] = v)
            })
          } else if (typeof val === 'object' && val !== null) {
            flatten(val, path, res)
          } else {
            res[path] = val
          }
        })
        return res
      }
      const pretty = p => p.replace(/\.\(/g, ' → ').replace(/\)\./g, ' → ').replace(/\./g, ' → ').replace(/[()]/g, '').replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
      const display = v => (v === undefined || v === null || v === '') ? '—' : typeof v === 'object' ? JSON.stringify(v) : String(v)
      const oldFlat = flatten(properties.old || {})
      const newFlat = flatten(properties.new || {})
      const keys = new Set(Object.keys(oldFlat).concat(Object.keys(newFlat)))
      return Array.from(keys).map(k => ({ field: pretty(k), old: display(oldFlat[k]), new: display(newFlat[k]) })).filter(r => r.old !== r.new)
    },
  },
  watch: {
    page() {
      if (this.id) this.fetchLogs()
    },
    perPage() {
      if (this.id) this.fetchLogs()
    },
  },
}
</script>

<style scoped>
.status-log-pop-up >>> .vs-popup {
  min-width: 50% !important;
}
</style>
